// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"LocationSearchInput_dropdown__2vBWD","suggestion":"LocationSearchInput_suggestion__209Pj","active":"LocationSearchInput_active__2NnXw"};